import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} 好看的韩国漫画封面`}
          title={`${comic.title} 好看的韩国漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2.5">
          <span className="rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
            {comic.genre}
          </span>
          <span className="flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
            <i className="ri-star-fill text-xs" />
            {comic.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-foreground-950/80 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      </div>
      <div className="p-3.5">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {comic.title}
        </h3>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span>{comic.status}</span>
          <span>{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}